import Container from './container';
import SchoolPrograms from './schoolPrograms';

export default Container(SchoolPrograms);



// WEBPACK FOOTER //
// ./src/routes/account/schoolPrograms/index.js